const ChatGatewayProvider = Object.freeze({
  TELEGRAM_BOT: 'telegram',
  TELEGRAM_APP: 'gotd',
  MESSENGER: 'messenger',
  VIBER: 'viber',
  WEBCHAT: 'webchat',
  INFOBIP: 'infobip_whatsapp',
});

export default ChatGatewayProvider;
